import { Link } from "react-router-dom";
import { StoreHeader } from "./StoreHeader";
import { StoreFooter } from './StoreFooter';
import { useEffect } from "react";

export function PlugLanding() {

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, []);

  return (
    <div className="min-h-screen bg-stone-50 text-stone-800">
      <StoreHeader />

      {/* Hero Banner */}
      <section className="relative bg-gradient-to-r from-red-600 via-emerald-700 to-emerald-900 text-white">
        <div className="absolute inset-0 bg-black/40" />

        <div className="relative max-w-6xl mx-auto px-6 py-24 text-center">
          <h1 className="text-3xl md:text-5xl font-extrabold tracking-tight leading-tight mb-6">
            Welcome to{" "}
            <span className="text-yellow-300 block md:inline">
              Megamart Juza aka M-Juza
            </span>
          </h1>

          <p className="text-base md:text-xl max-w-3xl mx-auto text-white/90">
            The knowledge corner — ambapo unajuzwa.
            Shopping tips, product guides, and Nairobi vibes, all in one place.
          </p>

          <Link
            to="/products"
            className="inline-flex items-center justify-center mt-8 rounded-lg
                       bg-yellow-400 px-8 py-3 text-base font-semibold text-black
                       hover:bg-yellow-500 transition-colors"
          >
            Shop Now
          </Link>
        </div>
      </section>

      {/* Featured Articles */}
      <section className="max-w-7xl mx-auto px-6 py-16">
        <header className="mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-emerald-900">
            Latest Guides
          </h2>
          <p className="mt-2 text-stone-600 max-w-2xl">
            Straight talk on appliances, tech, and lifestyle — Nairobi style.
          </p>
        </header>

        <div className="grid gap-8 sm:grid-cols-2 lg:grid-cols-3">
          {/* Kitchen */}
          <Card title="Ndio Hii Air Fryer, Bro! 🍟🔥" desc="How to use, care, and choose the right fryer for your budget." link="/plug/air-fryer" />
          <Card title="Pressure Cooker Plug 🍲" desc="Safety tips, recipes, and which cooker fits your lifestyle." link="/plug/pressure-cooker" />
          <Card title="Blender Chronicles 🥤" desc="Smoothies, sukuma wiki soup, and hustle hacks." link="/plug/blender" />
          <Card title="Coming Soon: Microwave Diaries 🍲" desc="The bachelor’s lifeline — reheating ugali at midnight." link="/plug/microwave" />
          <Card title="Coming Soon: Rice Cooker Plug 🍚" desc="Pilau bila stress — perfect rice every time." link="/plug/rice-cooker" />

          {/* Breakfast & Snacks */}
          <Card title="Coming Soon: Toaster Tales 🍞" desc="Bread, but make it crispy." link="/plug/toaster" />
          <Card title="Coming Soon: Coffee Maker Plug ☕" desc="CEO vibes at 6am — hustle fuel." link="/plug/coffee-maker" />
          <Card title="Coming Soon: Juicer Plug 🍊" desc="Vitamin C bila hawker drama." link="/plug/juicer" />
          <Card title="Coming Soon: Mixer Plug 🥧" desc="Cakes that don’t flop like bad proposals." link="/plug/mixer" />
          <Card title="Coming Soon: Oven Plug 🍕" desc="Become the chef your mama doubted." link="/plug/oven" />

          {/* Tech */}
          <Card title="Coming Soon: Smartphone Showdown 📱" desc="Apple, Samsung, Google — which phone is the real Nairobi plug?" link="/plug/smartphones" />
          <Card title="Coming Soon: Laptop Plug 💻" desc="Smooth Zoom calls, no frozen screens." link="/plug/laptop" />
          <Card title="Coming Soon: Smartwatch Chronicles ⌚" desc="Your wrist shouting ‘enda gym, bro!’." link="/plug/smartwatch" />
          <Card title="Coming Soon: Earbuds Plug 🎧" desc="Noise cancellation — peace in matatus." link="/plug/earbuds" />
          <Card title="Coming Soon: TV Plug 📺" desc="Neighbors will think you opened a cinema." link="/plug/tv" />

          {/* Home */}
          <Card title="Coming Soon: Vacuum Cleaner Plug 🧹" desc="Dust-free house, hakuna sweeping drama." link="/plug/vacuum" />
          <Card title="Coming Soon: Iron Box Plug 👔" desc="Sharp shirts, CEO vibes." link="/plug/iron" />
          <Card title="Coming Soon: Fan Plug 🌬️" desc="Cool nights, KPLC backup." link="/plug/fan" />
          <Card title="Coming Soon: Fridge Plug 🧊" desc="Fresh food, hide soda from roommates." link="/plug/fridge" />
          <Card title="Coming Soon: Washing Machine Plug 🧺" desc="No more river laundry chronicles." link="/plug/washing-machine" />

          {/* Lifestyle */}
          <Card title="Coming Soon: Gaming Console Plug 🎮" desc="Escape Nairobi traffic in GTA." link="/plug/gaming-console" />
          <Card title="Coming Soon: Camera Plug 📸" desc="Become the next TikTok star." link="/plug/camera" />
          <Card title="Coming Soon: Speaker Plug 🔊" desc="Neighbors will know you’re the DJ." link="/plug/speaker" />
          <Card title="Coming Soon: Smart Home Plug 🏠" desc="Tell Alexa to switch off lights like a boss." link="/plug/smart-home" />
          <Card title="Coming Soon: Router Plug 🌐" desc="No more buffering during EPL matches." link="/plug/router" />

          {/* Personal Care */}
          <Card title="Coming Soon: Hair Dryer Plug 💇" desc="Salon at home — drip drying no more." link="/plug/hair-dryer" />
          <Card title="Coming Soon: Shaver Plug 🪒" desc="Avoid looking like a forest ranger." link="/plug/shaver" />
          <Card title="Coming Soon: Perfume Plug 🌸" desc="Smell like Dubai duty-free, not bus stage." link="/plug/perfume" />
          <Card title="Coming Soon: Sneaker Plug 👟" desc="Walk like you own Nairobi CBD." link="/plug/sneakers" />
          <Card title="Coming Soon: Handbag Plug 👜" desc="Carry everything except rent." link="/plug/handbag" />

          {/* Extras */}
          <Card title="Coming Soon: Water Dispenser Plug 💧" desc="Tea ready faster than gossip spreads." link="/plug/water-dispenser" />
        </div>
      </section>

      {/* Footer */}
      <footer className="border-t bg-stone-100 py-8 text-center text-sm text-stone-600">
        © {new Date().getFullYear()} Megamart.co.ke — The Plug: Shopping tips with Nairobi flavor.
      </footer>
      <StoreFooter />
    </div>
  );
}

/* Card Component */
function Card({ title, desc, link }) {
  return (
    <article className="group h-full rounded-xl bg-white p-6 shadow-sm transition
                        hover:shadow-lg hover:-translate-y-0.5">
      <h3 className="mb-2 text-lg font-semibold text-red-600 leading-snug">
        {title}
      </h3>

      <p className="mb-5 text-sm leading-relaxed text-stone-600">
        {desc}
      </p>

      <Link
        to={link}
        className="inline-flex items-center text-sm font-semibold text-emerald-700
                   group-hover:underline"
      >
        Read More →
      </Link>
    </article>
  );
}
